import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { images } from "../../data/landingContent";
const perks = ["6 Premium Volumes", "5 Exclusive Bonuses", "Instant Digital Access", "One-Time Payment", "7-Day Money-Back Guarantee"];
export function FinalCtaSection() {
  return <section className="bg-plum px-4 py-14 text-white sm:py-20" data-id="element-157" data-mp="2dik3arjvhqi9">
      <div className="mx-auto max-w-2xl text-center" data-id="element-158" data-mp="2riurtnxpmt09">
        <h2 className="text-balance font-serif text-[30px] font-bold leading-tight sm:text-4xl" data-id="element-159" data-mp="2rhbfg8f6d23r">
          Your next menopause consultation deserves a <em className="text-[#FFD7E3]" data-id="element-160" data-mp="318o2mmq1343g">clearer structure</em>
        </h2>
        <div className="mt-6 space-y-3 text-[17px] leading-relaxed text-white/85" data-id="element-161" data-mp="31as5r2g3rz2o">
          <p data-id="element-162" data-mp="2wamjy2wil6si">You don't need to memorize every guideline.</p>
          <p data-id="element-163" data-mp="3aannxr82suc7">You don't need to rebuild your consultation resources from scratch.</p>
          <p data-id="element-164" data-mp="368k9ctq419mp">
            With Menopause Decision Map™, you'll have six practical volumes and five additional bonuses to consult,
            adapt, and integrate into your professional workflow.
          </p>
        </div>
        <p className="mt-6 font-serif text-2xl font-bold leading-snug" data-id="element-165" data-mp="2637ozhuz0dec">
          The clinical decisions remain yours.
          <br data-id="element-166" data-mp="2azy15u3nmouh" />
          <em className="text-[#FFD7E3]" data-id="element-167" data-mp="2b3c5v8zsja53">The maps help you organize the path.</em>
        </p>
        <img src={images.hero} alt="Menopause Decision Map™ collection" className="mx-auto mt-6 w-full max-w-lg" data-id="element-168" data-mp="2fy9am3q1exc6" />
        <ul className="mx-auto mt-4 flex max-w-lg flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-169" data-mp="2kxm6fdyvzeqw">
          {perks.map(p => <li key={p} className="flex items-center gap-1.5 text-sm font-semibold" data-id="element-170" data-mp="2tr8qw7xn8vks">
              <CheckIcon className="h-4 w-4 text-[#86EFAC]" aria-hidden="true" data-id="element-171" data-mp="2yqk9znlhgd5j" />
              {p}
            </li>)}
        </ul>
        <CtaButton className="mt-8" label="Yes! I want Menopause Decision Map™" data-id="element-172" data-mp="33r7ya1ibufw2" />
        <p className="mt-3 text-sm text-white/80" data-id="element-173" data-mp="38o86oj2nfuqc">Only $27 USD · Instant Digital Access · No Subscription</p>
      </div>
    </section>;
}